
'use strict';
import {Injectable, Inject} from 'ng-metadata/core';
import {StorageUtil} from "../../storageUtil.service";



@Injectable()
export class ModelService {
    private activeStatus;
    private model : Object;
    private aggregatedEntries : Array<string> = ['pnxs'];
    constructor(private storageUtil: StorageUtil) {
        this.activeStatus = false;
        this.model = {};
    }





    public getKey(url){
        let start = 0;
        if(url.lastIndexOf('/rest/v1/') !== -1) {
            start = url.lastIndexOf('/rest/v1/') + '/rest/v1/'.length;
        }else if(url.lastIndexOf('/rest/primo-explore/v1/') !== -1){
            start = url.lastIndexOf('/rest/primo-explore/v1/') + '/rest/primo-explore/v1/'.length;
        }
        let end = url.indexOf('?') !== -1 ? url.indexOf('?') : url.length;
        let key = url.substring(start, end);
        return key;
    }

    public addToModel(key,response){
        this.storageUtil.$localForage.getItem('debugModel').then((data) => {

            if (!data){
                data = {};
            }

            if(!data[key]){
                if(this.aggregatedEntries.indexOf(key) !== -1){
                    data[key] = [];
                }else {
                    data[key] = {};
                }
            }
            if(this.aggregatedEntries.indexOf(key) !== -1){
                if(response.config.params.offset === 0) {
                    data[key] = [];
                }
                data[key].push(response.data);
            }else{
                data[key] = response.data;
            }


            this.storageUtil.$localForage.setItem('debugModel', data);
            this.model = data;

            
        });


    }

    get modelInstance(){
        this.getDatModel();
        return this.model;
    }

    set modelInstance(object){
        this.model = object;
    }

    get active(){
        this.checkActive();
        return this.activeStatus;
    }

    public getDatModel(){
        this.storageUtil.$localForage.getItem('debugModel').then((data) => {
            this.model = data || {};
        });
    }
    
    public checkActive(){
        this.storageUtil.$localForage.getItem('debugModelActive').then((data) => {
            this.activeStatus = data || false;
        });
    }

    set active(active){
        if(active){
            this.storageUtil.$localForage.getItem('debugModelActive').then((data) => {
                this.activeStatus = data || active;
                this.storageUtil.$localForage.setItem('debugModelActive', this.activeStatus);
            });

        }

    }


}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/dataStructures/model/model.service.ts